// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"pqyqDB","Fullscreen":"_Z1__K"};